<template>
  <v-row style="border: 1px solid gray; margin-bottom: 30px">
    <v-col cols="12">
      <div>
        <h1>Upload iWyze Campaign Leads</h1>
        <h3>Upload list of iWyze leads to be added to OneStream</h3>
        <p>Only XLSX documents allowed</p>
        <div class="pb-6">
          <a
            href="/example_files/iwyze_upload_example.xlsx"
            download="iwyze_upload_example.xlsx"
            >View example of file to upload</a
          >
        </div>
        <v-file-input
          v-model="file"
          single-line
          outlined
          dense
          filled
          :loading="buttonLoading"
          label="Upload file"
          class="file-upload-btn"
        />
      </div>
      <v-btn
        rounded
        depressed
        :loading="buttonLoading"
        color="primary"
        @click="uploadFile()"
        ><span>Upload</span></v-btn
      >

      <v-progress-linear
        v-if="isProcessing"
        :value="progress"
        height="25"
        striped
      >
        <template v-slot:default="{ value }">
          <strong>
            {{ Math.ceil(value || 0) }}% ({{ processedRows || 0 }}/{{
              totalRows || 0
            }})
          </strong>
        </template>
      </v-progress-linear>
    </v-col>

    <v-col cols="12">
      <v-progress-circular
        v-if="isPolling"
        indeterminate
        color="primary"
      ></v-progress-circular>
      <h1 v-if="lastJobFinishedSuccessfully">
        Last batch with ID {{ latBatchId }} finished successfully
      </h1>
    </v-col>
  </v-row>
</template>

<script>
  import {
    UPLOAD_IWIZE_JOB_LIST_MUTATION,
    POLL_IWYZE_JOB_LIST_STATUS_MUTATION,
  } from '../../constants/graphql/daily-tasks';
  export default {
    name: 'IwyzeUploadCampaignLeads',
    data() {
      return {
        file: null,
        buttonLoading: false,
        intervalId: null,
        iwyzeJobChanges: null,
        isProcessing: false,
        lastJobFinishedSuccessfully: false,
        latBatchId: null,
        isPolling: false,
        progress: 0,
        totalRows: 0,
        processedRows: 0,
        isInitialPoll: true,
      };
    },
    created() {
      this.pollStatus();
      this.startPolling();
    },
    methods: {
      uploadFile() {
        this.lastJobFinishedSuccessfully = false;
        if (this.file) {
          this.buttonLoading = true;
          var reader = new FileReader();
          reader.readAsDataURL(this.file);
          reader.onload = function (evt) {
            const fileBase64 = evt.target.result;
            this.uploadFileInformation(fileBase64);
          }.bind(this);
        }
      },
      uploadFileInformation(fileBase64) {
        const testatorId = this.$store.getters.testatorId;

        this.$apollo
          .mutate({
            mutation: UPLOAD_IWIZE_JOB_LIST_MUTATION,
            variables: {
              testatorId,
              fileBase64,
            },
          })
          .then(_response => {
            this.iwyzeJobChanges = _response.data.uploadIwyzeJobList;
            if (this.intervalId) {
              this.stopPolling();
            }
            this.startPolling();
            this.buttonLoading = false;
            this.file = null;
            if (this.iwyzeJobChanges.totalRows > 0) {
              this.isProcessing = true;
              this.totalRows = this.iwyzeJobChanges.totalRows;
              this.processedRows = this.iwyzeJobChanges.processedRows;
              this.progress =
                (this.iwyzeJobChanges.processedRows /
                  this.iwyzeJobChanges.totalRows) *
                100;
            }
          })
          .catch(error => {
            this.file = null;
            this.buttonLoading = false;
            alert(`Error: ${error.message}`);
          });
      },
      startPolling() {
        this.intervalId = setInterval(this.pollStatus, 5000);
      },
      stopPolling() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
        this.isProcessing = false;
        this.buttonLoading = false;
        this.isPolling = false;
        this.isInitialPoll = true;
      },
      pollStatus() {
        const testatorId = this.$store.getters.testatorId;

        if (this.isInitialPoll) {
          this.isPolling = true;
        }

        this.$apollo
          .mutate({
            mutation: POLL_IWYZE_JOB_LIST_STATUS_MUTATION,
            variables: {
              testatorId,
            },
          })
          .then(_response => {
            const status = _response.data.pollIwyzeJobListStatus;

            if (!status) {
              this.stopPolling();
              this.iwyzeJobChanges = null;
              this.isProcessing = false;
              this.buttonLoading = false;
              return;
            }

            this.isProcessing =
              status.status !== 'completed' &&
              status.status !== 'failed' &&
              status.totalRows > 0;

            if (this.isProcessing) {
              this.totalRows = status.totalRows;
              this.processedRows = status.processedRows;
              this.progress = (status.processedRows / status.totalRows) * 100;
            }

            if (status.status === 'completed') {
              this.isProcessing = false;
              this.buttonLoading = false;
              this.iwyzeJobChanges = status;
              this.lastJobFinishedSuccessfully = true;
              this.latBatchId = status.id;
            } else if (status.status === 'failed') {
              this.stopPolling();
              this.buttonLoading = false;
              alert('Processing failed: ' + status.errorMessage);
            }
          })
          .catch(error => {
            if (
              error.message === 'GraphQL error: No death check list jobs found'
            ) {
              this.stopPolling();
              return;
            }
            this.stopPolling();
          })
          .finally(() => {
            if (this.isInitialPoll) {
              this.isPolling = false;
              this.isInitialPoll = false;
            }
          });
      },
    },
    beforeDestroy() {
      this.stopPolling();
    },
    beforeDestroy() {
      this.stopPolling();
    },
  };
</script>

<style lang="scss" scoped>
  .death-check-list-table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    margin-bottom: 10px;
  }

  .death-check-list-table thead {
    background-color: #f4f4f4;
  }

  .death-check-list-table th,
  .death-check-list-table td {
    padding: 10px;
    text-align: left;
    border: 1px solid #ddd;
  }

  .death-check-list-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  .death-check-list-table tbody tr:nth-child(odd) {
    background-color: #fff;
  }

  .death-check-list-table th {
    font-weight: bold;
  }

  .death-check-list-table td {
    transition: background-color 0.3s ease;
  }

  .death-check-list-table tbody tr:hover {
    background-color: #f1f1f1;
  }
</style>
